import api from '../api/index.js';
// import Exif from "exif-js";
import qs from 'qs'
const wx = window.wx
export default {
    windowClose:function(){
        console.log('---s')
            setTimeout(function() {
              //这个可以关闭安卓系统的手机
              document.addEventListener(
                "WeixinJSBridgeReady",
                function() {
                  WeixinJSBridge.call("closeWindow");
                },
                false
              );
              //这个可以关闭ios系统的手机
              WeixinJSBridge.call("closeWindow");
            }, 300);
    },
    /**
     *
     * 年月日
     */
    getYearMonthDay:function(date) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let time = ""
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        time = year + '-' +month + '-' +day
        return { year, month, day ,time};
    },
    /**
     * 手机号验证
     */
    formatPhone:function(phone){
        let phoneFormat = /^1[345789]\d{9}$/
        if ((phoneFormat.test(phone))) {
            return true
        } else {
            return false
        }
    },
    /**
     * 获取年龄
     */
    age:function(date) {
        if(!date){
            return ""
        }
        var tmpBirth = {};
		tmpBirth.year = 0;
		tmpBirth.month = 0;
		tmpBirth.day = 0;
        var startDate = new Date(date);
        var endDate = new Date();
        endDate = new Date();
		//var days = endDate.getTime()-startDate.getTime();
		//var day = parseInt(days/(1000*60*60*24));

		var startYear = startDate.getFullYear();
		var endYear = endDate.getFullYear();
		var startMonth = startDate.getMonth()+1;
		var endMonth = endDate.getMonth()+1;
		var startDay = startDate.getDate();
        var endDay = endDate.getDate();
		var allDays = 0;
		//准确的每个月天数数组，判断闰年平年。
		var allDayArr = [];
		//当月计算
		if(startYear==endYear&&startMonth==endMonth){
			 tmpBirth.day = endDay-startDay + 1;
			 return formatAge(tmpBirth);
		}
		//正常计算
		for(var i=startYear;i<=endYear;i++){
			var currYear = 365
			var yearMonth = 12;
			if(((i%4==0&&i%100!=0)||i%400==0)){
				allDays+=366;
				currYear = 366;
			}
			var currMonth=1;
			if(i==startYear){
				currMonth = startMonth;
			}
			if(i==endYear){
				yearMonth = endMonth;
			}
			//闰年计算
			for(var m=currMonth;m<=yearMonth;m++){
				var fullDays=30;

				 if(m==1||m==3||m==5||m==7||m==8||m==10||m==12){
					fullDays = 31
				 }else  if(m==2){
					if(((i%4==0&&i%100!=0)||i%400==0)){
						fullDays = 29;
					}else{
						fullDays = 28;
					}
				 }
				var dayObj = {
					fullDays:fullDays,
					currDays:fullDays
				};
				if(m==startMonth&&i==startYear){
					dayObj = {
						fullDays:fullDays,
						currDays:fullDays - startDay + 1
					};
				}else
				if(m==endMonth&&i==endYear){
					dayObj = {
						fullDays:fullDays,
						currDays:endDay
					};
				}
				allDayArr.push(dayObj);
			}
		}
		if(allDayArr.length==1){
			tmpBirth.day = allDayArr[0].currDays;
		}else
		if(allDayArr.length==2){
			var d1 = allDayArr[0].currDays;
			var d2 = allDayArr[1].currDays;
            //月份天数浮动因子决定准确性
            var cfDay = allDayArr[0].fullDays;
			// var cfDay = allDayArr[0].fullDays>allDayArr[allDayArr.length-1].fullDays?allDayArr[allDayArr.length-1].fullDays:allDayArr[0].fullDays;
			if((d1+d2)>=cfDay){
				tmpBirth.day = (d1+d2)-cfDay;
				tmpBirth.month +=1;
			}else{
				tmpBirth.day = d1+d2;
			}
		}else{
			var d1 = allDayArr[0].currDays;
			var d2 = allDayArr[allDayArr.length-1].currDays;
			var sumFullDay = 0;
			for(var i=0;i<allDayArr.length;i++){
				sumFullDay+=allDayArr[i].fullDays;
			}
			//var cfDay = sumFullDay/allDayArr.length;//
			var cfDay = allDayArr[0].fullDays;
			//月份天数浮动因子决定准确性
            // var cfDay = allDayArr[0].fullDays>allDayArr[allDayArr.length-1].fullDays?allDayArr[allDayArr.length-1].fullDays:allDayArr[0].fullDays;

			if((d1+d2)>=cfDay){
				tmpBirth.day = (d1+d2)-cfDay;
				tmpBirth.month +=1;
			}else{
				tmpBirth.day = d1+d2;//-(allDayArr[allDayArr.length-1].fullDays-allDayArr[allDayArr.length-2].fullDays);
			}
			tmpBirth.month += allDayArr.length-2;

			if(tmpBirth.month>=12){
				tmpBirth.year +=Math.floor(tmpBirth.month/12);
				tmpBirth.month = tmpBirth.month-(tmpBirth.year*12);
			}
        }

        function formatAge(obj){
            let ageOfstring;
            if(obj.year){
                ageOfstring = obj.year +'岁'
            }else{
                if(obj.month){
                    ageOfstring = obj.month +'月' + (obj.day? obj.day +'天':'')
                }else{
                    if(obj.day){
                        ageOfstring =  obj.day +'天'
                    }

                }
            }
            return ageOfstring
        }
		return formatAge(tmpBirth);
    },
    /**
     * 根据不同机型获取时间
     */
    dateFormatByPhone:function(date){
        let returnDate = ""
        //Android终端
        let isAndroid = /(Android)/i.test(navigator.userAgent);
   　   //Ios终端
        let isiOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
        if(isiOS) {
            returnDate = new Date(date.replace(/-/g, "/"))
        }
        if(isAndroid){
            returnDate = new Date(date)
        }
        return returnDate
    },
    /**
     * 查看是不是来自医生端
     */
    getFromType:function(type){
        let isDoctor = false
        if(type === 'doctor'){
            isDoctor = true
        }
        return isDoctor
    },
    timeFormat:function(fmt,value){
        var theTime = parseInt(value / 1000); // 秒
        var middle = 0; // 分
        var hour = 0; // 小时

        if (theTime > 60) {
          middle = parseInt(theTime / 60);
          theTime = parseInt(theTime % 60);
          if (middle > 60) {
            hour = parseInt(middle / 60);
            middle = parseInt(middle % 60);
          }
        }
        function getTime(time){
          let returnString = time
          if(time < 10){
              returnString = '0' + time
          }
          return returnString
        }
        var o = {
            "H+" : parseInt(hour), //小时
            "m+" : parseInt(middle), //分
            "s+" : parseInt(theTime), //秒
        };
        for(var k in o){
	        if(new RegExp("("+ k +")").test(fmt)){
	            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
	        }
        }
        return fmt
    },
	/**
	 * 对Date的扩展，将 Date 转化为指定格式的String
	 * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q) 可以用 1-2 个占位符
	 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
	 * eg:
	 * (new Date()).pattern("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
	 * (new Date()).pattern("yyyy-MM-dd E HH:mm:ss") ==> 2009-03-10 二 20:09:04
	 * (new Date()).pattern("yyyy-MM-dd EE hh:mm:ss") ==> 2009-03-10 周二 08:09:04
	 * (new Date()).pattern("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
	 * (new Date()).pattern("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
	 */
	dateFormat:function(fmt,date)
	{
		if(date){
          typeof date === 'string'&&date.indexOf('-')===-1&& (date = parseInt(date))
          if(typeof date === 'string'){
            //Android终端
            let isAndroid = /(Android)/i.test(navigator.userAgent);
      　       //Ios终端
            let isiOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
            if(isiOS) {
                var date = new Date(date.replace(/-/g, "/"))
            }
            if(isAndroid){
                var date = new Date(date)
            }
          }else{
            var date =  new Date(date)
          }

		}else{
			var date = new Date();
        }
        // console.log('datedate',fmt,date,new Date())
        // %12 == 0 ? 12 : date.getHours()%12
		var o = {
	    "M+" : date.getMonth()+1, //月份
	    "d+" : date.getDate(), //日
	    "h+" : date.getHours(), //小时
	    "H+" : date.getHours(), //小时
	    "m+" : date.getMinutes(), //分
	    "s+" : date.getSeconds(), //秒
	    "q+" : Math.floor((date.getMonth()+3)/3), //季度
	    "S" : date.getMilliseconds() //毫秒
	    };
	    var week = {
	    "0" : "日",
	    "1" : "一",
	    "2" : "二",
	    "3" : "三",
	    "4" : "四",
	    "5" : "五",
	    "6" : "六"
	    };
	    if(/(y+)/.test(fmt)){
	        fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
	    }
	    if(/(E+)/.test(fmt)){
	        fmt=fmt.replace(RegExp.$1, ((RegExp.$1.length>1) ? (RegExp.$1.length>2 ? "星期" : "周") : "")+week[date.getDay()+""]);
	    }
	    for(var k in o){
	        if(new RegExp("("+ k +")").test(fmt)){
	            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
	        }
        }
        // console.log('fmt',fmt,date.getFullYear())
	    return fmt;
	},
	phoneType:function() {
        //Android终端
        let isAndroid = /(Android)/i.test(navigator.userAgent);
   　   //Ios终端
        let isiOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
        return {
        	isAndroid:isAndroid,
        	isiOS:isiOS
        }
    },
	/**
	* @method :微信支付方法
	* @param data
	*/
	weixinPay:function(data,callback){
		if (typeof WeixinJSBridge == "undefined"){//微信浏览器内置对象。参考微信官方文档
			if( document.addEventListener ){
				document.addEventListener('WeixinJSBridgeReady', callback(data), false);
			}else if (document.attachEvent){
				document.attachEvent('WeixinJSBridgeReady', callback(data));
				document.attachEvent('onWeixinJSBridgeReady',callback(data));
			}
		}else{
			callback(data);
		}
	},
	wxInit:function(jsApiList,callback){
        var jal = jsApiList && jsApiList.length ? jsApiList : ['hideMenuItems','closeWindow', 'showMenuItems'];
        var ua = window.navigator.userAgent.toLowerCase();
        console.log(wx)
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            let urls = window.location.href.split('#')[0];
            console.log(urls)
            api.wx.jsconfig({
                debug:false,
                jsApiList:jal,
                url : urls
            }).then(({data})=>{
                let params = {
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: data.appId, // 必填，公众号的唯一标识
                    timestamp: parseInt(data.timestamp), // 必填，生成签名的时间戳
                    nonceStr: data.nonceStr, // 必填，生成签名的随机串
                    signature: data.signature.toLowerCase(),// 必填，签名，见附录1
                    jsApiList: jal, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    openTagList: ['wx-open-launch-weapp','wx-open-launch-app']
                }
                console.log(params)
                wx.config(params);
                //隐藏右上角按钮
                wx.ready(function(){
                    callback&&callback();
                    // wx.hideMenuItems({
                    //     menuList: ['menuItem:share:appMessage','menuItem:share:timeline','menuItem:copyUrl','menuItem:openWithQQBrowser','menuItem:openWithSafari'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                    // });
                });
            })
        }else{
            callback&&callback();
        }
    },
    init:function (jsApiList,callback){
        var jal = jsApiList && jsApiList.length ? jsApiList : ['hideMenuItems','closeWindow', 'showMenuItems'];
        this.wxInit(jal,function(){
            wx.hideOptionMenu();
            callback&&callback(wx);
        });
    },
    closeWindow:function (closeWindow,callback){
        var jal = closeWindow||['hideMenuItems','closeWindow'];
        this.wxInit(jal,function(){
            wx.closeWindow();
            callback&&callback(wx);
        });
    },

    wXLocation:function (callback){

        // 调百度接口 获取详细地址
        function getLot(latitude, longitude, callback) {
            $.ajax({
                url: 'https://api.map.baidu.com/geocoder/v2/?ak=prGcofsDbA2ruqxy7VVt7lXXWaNHRPWz&callback=renderReverse&location=' + latitude + ',' + longitude + '&output=json&pois=1',
                type: "GET",
                // async:true, //异步请求
                dataType: "jsonp",
                jsonp: "callback",
                success: function (data) {
                    callback&&callback(data);
                }
            });
        };
        //微信
        var jal = ['getLocation','hideMenuItems','closeWindow'];
        this.wxInit(jal,function(){
            wx.hideOptionMenu();
            wx.getLocation({
                success:function (res) { //接口调用成功时执行的回调函数
                    var latitude = res.latitude;
                    var longitude = res.longitude;
                    //经纬转换 城市名称
                    getLot(latitude,longitude,function(data){
                        callback&&callback(data);
                    });
                },
                fail:function(){  //接口调用失败时执行的回调函数
                    callback&&callback(0);
                },
                cancel:function(){ //用户点击取消时的回调函数
                    callback&&callback(0);
                }
            });
        });
    },

    wXShare:function (desc, title, img, url, showMenuItems = null){
        img = img || '';
        title = title || document.title;
        desc = desc || document.title;
        url = url || document.location.href;
        var jal = ['onMenuShareTimeline','onMenuShareAppMessage','closeWindow','showMenuItems','hideMenuItems'];
        this.wxInit(jal,function(){
            wx.hideOptionMenu();
            wx.showMenuItems({
                menuList: showMenuItems || ['menuItem:share:appMessage','menuItem:share:timeline'] // 要显示的菜单项，所有menu项见附录3
            });
            //2015年8月27日    分享朋友圈
            wx.onMenuShareTimeline({
                title: title, // 分享标题
                link: url, // 分享链接
                imgUrl: img, // 分享图标
                success: function (res) {
                    //alert('已分享');
                },
                cancel: function (res) {
                    //alert('已取消');
                },
                fail: function (res) {
                    //alert(JSON.stringify(res));
                }
            });
            //分享给朋友
            wx.onMenuShareAppMessage({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: url, // 分享链接
                imgUrl: img, // 分享图标
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function (res) {
                    //alert('已分享');
                },
                cancel: function (res) {
                    //alert('已取消');
                },
                fail: function (res) {
                    //alert(JSON.stringify(res));
                }
            });

        });
    },

    wXShareAllMenu:function (desc, title, img, url){
        img = img || '';
        title = title || document.title;
        desc = desc || document.title;
        url = url || document.location.href;
        var jal = [
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "onMenuShareQQ",
        "onMenuShareWeibo",
        "onMenuShareQZone",
      ];
        this.wxInit(jal,function(){
            //分享朋友圈
            wx.onMenuShareTimeline({
                title: title, // 分享标题
                link: url, // 分享链接
                imgUrl: img, // 分享图标
                success: function (res) {
                    //alert('已分享');
                },
                cancel: function (res) {
                    //alert('已取消');
                },
                fail: function (res) {
                    //alert(JSON.stringify(res));
                }
            });
            //分享给朋友
            wx.onMenuShareAppMessage({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: url, // 分享链接
                imgUrl: img, // 分享图标
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function (res) {
                    //alert('已分享');
                },
                cancel: function (res) {
                    //alert('已取消');
                },
                fail: function (res) {
                    //alert(JSON.stringify(res));
                }
            });
            //分享给QQ
            wx.onMenuShareQQ({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: url, // 分享链接
                imgUrl: img, // 分享图标
                success: function () {
                   // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                   // 用户取消分享后执行的回调函数
                }
            });
            //分享给腾讯微博
            wx.onMenuShareWeibo({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: url, // 分享链接
                imgUrl: img, // 分享图标
                success: function () {
                   // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
            //分享给QQ空间
            wx.onMenuShareQZone({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: url, // 分享链接
                imgUrl: img, // 分享图标
                success: function () {
                   // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
        });
    },

    wxUploadImg:function (callback){
        var jal = ['previewImage','uploadImage','chooseImage','hideMenuItems','getLocalImgData'];
        this.wxInit(jal,function(){
            wx.hideOptionMenu();
            callback&&callback();
            //2015年9月7日    分享朋友圈
        });
    },

    configInit:function (callback,isNoCache){
        var cacheTime = 86400000;
        var d1 = new Date()-0;
        var config = localStorage.getItem('naiterui_config_param_1');

        var configObj;
        if(config!=null&&typeof(config)!='undefined'&&config!=''&&!isNoCache){
            config = config.split('###');
            if(parseInt(config[0])>d1){
                try{
                    configObj = JSON.parse(config[1]);
                    configObj&&callback(configObj);
                }catch(e){
                    getData(callback);
                }
            }else{
                getData(callback);
            }
        }else{
            getData(callback);
        }

        function getData(callback){
        	COMMON_API.getConfigParams().then(function(v){
				if(v.code==0){
                    localStorage.setItem('naiterui_config_param_1',d1+cacheTime+'###'+JSON.stringify(v.data[0]));
                    configObj = v.data[0];
                    configObj&&callback(configObj);
                }else{
                    getCatchData(callback);
                }
			});
        }

        function getCatchData (callback){
            var config = localStorage.getItem('naiterui_config_param_1');
            if(config!=null&&typeof(config)!='undefined'){
                config = config.split('###');
                try{
                    configObj = JSON.parse(config[1]);
                    configObj&&callback(configObj);
                }catch(e){
                }
            }
        }
    },

    previewImage:function (current, urls){
        wx.previewImage({
            current: current, // 当前显示图片的http链接
            urls: urls // 需要预览的图片http链接列表
        });
    },
    wxChooseImage:function (count, callback){
        this.wxUploadImg();
        let _this = this
        wx.chooseImage({
            count: count, // 默认9
            sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
            success: function (res) {
                var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                //modify by sunlc  2015年12月9日 uploadImage在chooseImage的回调中有时候Android会不执行，Android6.2会解决此问题，若需支持低版本可以把调用uploadImage放在setTimeout中延迟100ms解决
                window.setTimeout(function(){
                    _this.wxUpImage(0,localIds,callback);
                },100);

            }
        });
    },

    //add by sunlc  上传图片，一次可以多张 2015年9月8日
    wxUpImage:function (id,localIds,callback){
        let that = this;
        this.wxUploadImg();
        wx.uploadImage({
            localId: localIds[id], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function (res) {
                var serverId = res.serverId; // 返回图片的服务器端ID
                callback&&callback(serverId)
                if(id<localIds.length){
                    that.wxUpImage(++id,localIds,callback);
                }
            }
        });
    },
    /**
     * [go 跳转到以前引擎页面，统一加版本号]
     * @param  {[type]} url [description]
     * @return {[type]}     [description]
     */
    go:function(url){
        let iVersion = '20190627';
        let vIndex = parseInt(url.indexOf('#'));
        let hrefVersion = '';
        if(vIndex!=-1){
            let vHtmlAddr = url.substr(0,vIndex);
            let vParamsAddr = url.substr(vIndex);
            hrefVersion = vHtmlAddr +'?v='+iVersion+vParamsAddr;
        }else{
            hrefVersion = url + '?v='+iVersion;
        }
        if(url.indexOf('http')!=-1&&url.indexOf('https')!=-1){
            location.href = url;
        }else{
            location.href = hrefVersion;
        }

    },
    imgPreview:function(file,callback){
        let self = this;
        let Orientation;
        //去获取拍照时的信息，解决拍出来的照片旋转问题
        Exif.getData(file, function() {
          Orientation = Exif.getTag(this, "Orientation");
        });
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return;

        if (/^image/.test(file.type)) {
          // 创建一个reader
          let reader = new FileReader();

          // 将图片2将转成 base64 格式
          reader.readAsDataURL(file);

          // 读取成功后的回调
          reader.onloadend = function() {
            let result = this.result;
            let img = new Image();
            img.src = result;
            //判断图片是否大于100K,是就直接上传，反之压缩图片
            if (this.result.length <= 100 * 1024) {
              callback&&callback(this.result)
            } else {
              img.onload = function() {
                let data = self.compress(img, Orientation);
                callback&&callback(data)
              };
            }
          };
        }
    },
    compress:function(img, Orientation) {
        let _this = this
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        //瓦片canvas
        let tCanvas = document.createElement("canvas");
        let tctx = tCanvas.getContext("2d");
        let initSize = img.src.length;
        let width = img.width;
        let height = img.height;
        //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
        let ratio;
        if ((ratio = width * height / 4000000) > 1) {
          console.log("大于400万像素");
          ratio = Math.sqrt(ratio);
          width /= ratio;
          height /= ratio;
        } else {
          ratio = 1;
        }
        canvas.width = width;
        canvas.height = height;
        //        铺底色
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        //如果图片像素大于100万则使用瓦片绘制
        let count;
        if ((count = width * height / 1000000) > 1) {
          console.log("超过100W像素");
          count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
          //            计算每块瓦片的宽和高
          let nw = ~~(width / count);
          let nh = ~~(height / count);
          tCanvas.width = nw;
          tCanvas.height = nh;
          for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
              tctx.drawImage(
                img,
                i * nw * ratio,
                j * nh * ratio,
                nw * ratio,
                nh * ratio,
                0,
                0,
                nw,
                nh
              );
              ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
            }
          }
        } else {
          ctx.drawImage(img, 0, 0, width, height);
        }
        //修复ios上传图片的时候 被旋转的问题
        if (Orientation != "" && Orientation != 1) {
          switch (Orientation) {
            case 6: //需要顺时针（向左）90度旋转
              _this.rotateImg(img, "left", canvas);
              break;
            case 8: //需要逆时针（向右）90度旋转
              _this.rotateImg(img, "right", canvas);
              break;
            case 3: //需要180度旋转
              _this.rotateImg(img, "right2", canvas);
              break;
          }
        }
        //进行最小压缩
        let ndata = canvas.toDataURL("image/jpeg", 0.1);
        tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
        return ndata;
      },
      rotateImg:function(img, direction, canvas) {
        //最小与最大旋转方向，图片旋转4次后回到原方向
        const min_step = 0;
        const max_step = 3;
        if (img == null) return;
        //img的高度和宽度不能在img元素隐藏后获取，否则会出错
        let height = img.height;
        let width = img.width;
        let step = 2;
        if (step == null) {
          step = min_step;
        }
        if (direction == "right") {
          step++;
          //旋转到原位置，即超过最大值
          step > max_step && (step = min_step);
        } else if (direction == "right2") {
          step = 2;
        } else {
          step--;
          step < min_step && (step = max_step)
        }
        //旋转角度以弧度值为参数
        let degree = step * 90 * Math.PI / 180;
        let ctx = canvas.getContext("2d");
        switch (step) {
          case 0:
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0);
            break;
          case 1:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, 0, -height);
            break;
          case 2:
            canvas.width = width;
            canvas.height = height;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, -height);
            break;
          case 3:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, 0);
            break;
        }
      },

    /*
    check(ID)验证身份证号码
    返回值：0 : "是正确的身份证号"
            1 : "身份证校验不符合求和模11=1这个等式",
            2 : "身份证最后一位校验位有误",
            3 : "身份证位数不正确",
            4 : "年份错误",
            5 : "月份错误",
            6 : "日错误"

    */
    checkId:function(ID) {
        var ck = new IDCard();
        ck.check(ID);
        return ck.errNum;
    },

    filterCallingMessage:function(currentMessageList) {
    currentMessageList.forEach((item) => {
      if (item.callType) {   // 对于自己伪造的消息不需要解析
        return
      }
      if (item.type === TIM.TYPES.MSG_MERGER && item.payload.downloadKey !== '') {
        let promise = window.tim.downloadMergerMessage(item)
        promise.then(function(imResponse) {
          // 下载成功后，SDK会更新 message.payload.messageList 等信息
          item = imResponse
        }).catch(function(imError) {
          // 下载失败
          console.warn('downloadMergerMessage error:', imError)
        })
      }
      if(item.type === TIM.TYPES.MSG_CUSTOM) {
        let payloadData = {}
        try {
          payloadData = JSON.parse(item.payload.data)
        }catch (e) {
          payloadData = {}
        }
        if(payloadData.businessID === 1) {
          if(item.conversationType === TIM.TYPES.CONV_GROUP) {
            if(payloadData.actionType === 5) {
              item.nick = payloadData.inviteeList ? payloadData.inviteeList.join(','):item.from
            }
            let _text = window.trtcCalling.extractCallingInfoFromMessage(item)
            let group_text = `${_text}`
            item.type = TIM.TYPES.MSG_GRP_TIP
            let customData = {
              operationType: 256,
              text: group_text,
              userIDList: []
            }
            item.payload = customData//JSON.stringify(customData)
          }
          if(item.conversationType === TIM.TYPES.CONV_C2C) {
            let c2c_text = window.trtcCalling.extractCallingInfoFromMessage(item)
            let customData = {
              text: c2c_text
            }
            item.payload = customData//JSON.stringify(customData)
          }
        }
      }

    })
  }

}

function IDCard(ID) {
    var me = this;
    this.checkCode = new Array(1, 0,'x', 9, 8, 7, 6, 5, 4, 3, 2);
    this.ID;
    this.errNum = 0;
    this.err = {
        1 : "身份证校验不符合求和模11=1这个等式",
        2 : "身份证最后一位校验位有误",
        3 : "身份证位数不正确",
        4 : "年份错误",
        5 : "月份错误",
        6 : "日错误"
    };
    this.err_msg = function() {
        return (0 !== this.errNum) ? this.err[this.errNum] : null;
    };
    this.check = function(ID) {
        this.errNum = 0;
        this.ID = ID;
        if (cardValidate()) {
            if (!aiCheck()) this.errNum = 1;
            if (!LastByteCheck()) this.errNum = 2;
            return (0 === this.errNum) ? true: false;
        } else {
            return false;
        }
    };
    function getNum(str) {
        var re = /^[0]*([0-9]*)$/;
        str.match(re);
        return parseInt(RegExp.$1,10);
    }
    //对身份证位数，出生日期，初步验证
    function cardValidate() {
        var re = /^[0-9x]{15,18}$/i;
        if (!re.test(me.ID)) {
            me.errNum = 7;
            return false;
        }
        if (15 == me.ID.length || 18 == me.ID.length) {
            var realLen = 0;
            if (18 == me.ID.length) realLen = 2;
            var year = parseInt(me.ID.substr(6, 2 + realLen),10);
            var month = getNum(me.ID.substr(8 + realLen, 2));
            var day = parseInt(me.ID.substr(10 + realLen, 2),10);
            if (4 == year.length) if (year < 1900 || year > 2050) me.errNum = 4;
            if (month < 1 || month > 12) me.errNum = 5;
            if (day < 1 || day > 31) me.errNum = 6;
            return 0 === me.errNum;
        } else {
            me.errNum = 3;
            return false;
        }
    }
    //总和模11应该等于1
    var aiCheck = function() {
        var sum = 0;
        for (var i = 1; i <= me.ID.length; i++) {
            var ai = me.ID.substr(me.ID.length - i, 1);
            ai = (ai.toLowerCase() == 'x') ? 10 : ai;
            var wi = Math.pow(2, i - 1) % 11;
            sum += parseInt(ai,10) * wi;
        }
        return 1 == sum % 11;
    };
    //最后一位校验，这个可以和aiCheck合在一起，减少一次循环
    var LastByteCheck = function() {
        var sum = 0;
        for (var i = 2; i <= me.ID.length; i++) {
            var ai = me.ID.substr(me.ID.length - i, 1);
            ai = (ai.toLowerCase() == 'x') ? 10 : ai;
            var wi = Math.pow(2, i - 1) % 11;
            sum += parseInt(ai,10) * wi;
        }
        var checkCodeIndex = sum % 11;
        var c = me.ID.substr(me.ID.length - 1, 1);
        //alert(c+"=="+me.checkCode[checkCodeIndex]);
        return c.toLowerCase() == me.checkCode[checkCodeIndex];
    };

}



// WEBPACK FOOTER //
// ./src/utils/common.js